var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item"},[_c('router-link',{class:_vm.linkClass,attrs:{"to":_vm.linkTarget}},[_c('Icon',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }